import { Component, OnInit } from '@angular/core';

import { EmailTrackerModalComponent } from '../email-tracker-modal/email-tracker-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QuarantineService } from '../../services/quarantine/quarantine.service';
import { MessageService } from '../../../shared/message/service/message.service';
import { ArchiverService } from '../../services/archiver/archiver.service';

@Component({
  templateUrl: './email-archiver-modal.component.html',
  styleUrls: [
    '../email-tracker-modal/email-tracker-modal.component.scss',
    './email-archiver-modal.component.scss',
  ],
})
export class EmailArchiverModalComponent extends EmailTrackerModalComponent implements OnInit {

  constructor(
    protected archiverService: ArchiverService,
    public ngbActiveModal: NgbActiveModal,
    protected quarantineService: QuarantineService,
    protected messageService: MessageService,
  ) {
    super(archiverService, ngbActiveModal, quarantineService, messageService);
  }
}
